import { normalizeEmbryoName } from './normalizeEmbryoName';

export function countRecaneGroups(
  recaneEmbryos:
    | Array<{
        name?: string | null;
        cane?: string | null;
        creation?: string | null;
      }>
    | null
    | undefined,
  normalize = false,
): number {
  if (!Array.isArray(recaneEmbryos)) return 0;
  const groups = new Set(
    recaneEmbryos.map((e) =>
      normalize
        ? `${normalizeEmbryoName(e.name)}|${normalizeEmbryoName(e.cane)}|${e.creation ?? ''}`
        : `${e.name ?? ''}|${e.cane ?? ''}|${e.creation ?? ''}`,
    ),
  );
  return groups.size;
}
